import { render, staticRenderFns } from "./SpaceConfigurationExternalStorage.vue?vue&type=template&id=0f8aba84&"
import script from "./SpaceConfigurationExternalStorage.vue?vue&type=script&lang=js&"
export * from "./SpaceConfigurationExternalStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports